// extracted by mini-css-extract-plugin
module.exports = {"BlogNews":"BlogNews_BlogNews__391tb"};